import React, { useEffect, useState } from "react";
import "./index.css";

import mainLogo from "../../assets/images/logo.png";

const SplashScreen = ({ onFinish }) => {
  const [stage, setStage] = useState(1);

  useEffect(() => {
  // Dots collide
  const timer1 = setTimeout(() => setStage(2), 1000);

  // Background gradient
  const timer2 = setTimeout(() => setStage(3), 2000);

  // White overlay start expanding
  const timer3 = setTimeout(() => setStage(4), 3200);

  // Logo fade-in
  const timer4 = setTimeout(() => setStage(5), 4500);

  // Finish splash
  const timer5 = setTimeout(() => {
    setStage(6);
    if (onFinish) onFinish();
  }, 6000);

  return () => {
    clearTimeout(timer1);
    clearTimeout(timer2);
    clearTimeout(timer3);
    clearTimeout(timer4);
    clearTimeout(timer5);
  };
}, [onFinish]);

  return (
  <div className={`splash-wrapper`}>

    {stage >= 3 && stage <= 4 && (
      <div className="burst-gradient" />
    )}

    {/* Main background */}
    <div className={`splash-bg ${stage >= 4 ? "show-gradient" : ""}`} />

    {/* Dots */}
    {stage < 3 && (
      <div className="dots-wrapper">
        <div className={`dot left-dot ${stage >= 2 ? "collide" : ""}`} />
        <div className={`dot right-dot ${stage >= 2 ? "collide" : ""}`} />
      </div>
    )}

    {stage >= 4 && (
      <div className={`white-overlay ${stage >= 5 ? "full" : ""}`} />
    )}

    {stage >= 4 && stage <= 6 && (
      <img
        src={mainLogo}
        alt="Portal Logo"
        className={`splash-logo ${stage === 5 ? "fade-up" : ""}`}
      />
    )}
  </div>
);
};

export default SplashScreen;
